import { Injectable } from '@angular/core';
import { TwoFactorCredentials } from 'app/shared/model/security.model';
import { SecurityServiceProxy } from 'app/shared/services/security-service.proxy';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TwoFactorService {
    constructor(private _securityService: SecurityServiceProxy) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    /**
     * Get two factor credentials
     */
    getTwoFactorCredentials(): Observable<TwoFactorCredentials> {
        return this._securityService.getTwoFactorCredentials().pipe(
            switchMap((twofa) => {
                return of(twofa.credentials);
            })
        );
    }

    /**
     * check the passing in two factor code is valid or not
     */
    isValidTwoFactorCode(code: string): boolean {
        const reg = /^\d{6}$/i;
        return !!code && reg.test(code);
    }
}
